import './scss/main.scss';
import logoUrl from '../imgs/novcato_Horizontal_logo.svg';

document.querySelector('#brand-logo').src = logoUrl;

if (module.hot) {
  module.hot.accept();
}
